/**
 * assets/producto-confirmacion.js
 *
 * v3 --- corrige un bug real encontrado en pruebas: v2 escuchaba el clic
 * directamente sobre el botón "Agregar al carrito", compitiendo por el
 * mismo elemento con el listener propio del tema. Según el orden de carga,
 * a veces el tema ganaba la carrera y el producto se agregaba igual sin
 * confirmación --- verificado en vivo, no es una suposición.
 *
 * Corrección: se delega el clic desde `document` en fase de captura. Un
 * listener de captura puesto en document SIEMPRE se ejecuta antes que
 * cualquier listener puesto directamente sobre el botón, sin importar en
 * qué orden se cargó cada script --- así se elimina la condición de carrera
 * de raíz, no por suerte.
 *
 * Los botones NO se deshabilitan visualmente (decisión explícita): se ven
 * siempre activos. Si se hace clic sin haber marcado la casilla, se cancela
 * la acción, se hace scroll suave hasta la casilla, se le da foco y se
 * resalta brevemente. Si la casilla ya está marcada, el clic sigue su
 * curso normal sin ninguna interferencia.
 *
 * Limitación conocida: el botón "Comprar ahora" que se intercepta aquí es
 * la versión genérica (unbranded) del checkout dinámico de Shopify. Si en
 * el futuro se activan métodos de pago con botón propio (Shop Pay, Google
 * Pay, Apple Pay), esos suelen renderizarse dentro de un iframe de Shopify
 * por seguridad de pago, y un iframe de otro origen no se puede
 * interceptar desde este script. Revisar este archivo si se activan esos
 * métodos.
 */
(function () {
  var SELECTOR_BOTONES = 'button[name="add"], .shopify-payment-button__button';

  document.addEventListener(
    'click',
    function (event) {
      var checkbox = document.querySelector('[data-producto-confirmacion]');
      if (!checkbox || checkbox.checked) return;

      var boton = event.target.closest(SELECTOR_BOTONES);
      if (!boton) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      checkbox.focus();

      var contenedor = checkbox.closest('.lo-que-debes-saber__confirmacion');
      if (contenedor) {
        contenedor.classList.add('lo-que-debes-saber__confirmacion--resaltada');
        window.setTimeout(function () {
          contenedor.classList.remove('lo-que-debes-saber__confirmacion--resaltada');
        }, 2200);
      }
    },
    true
  );
})();
